/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum AllShipmentsSortDirection {
  Ascending = "Ascending",
  Descending = "Descending",
}

export function instanceOfAllShipmentsSortDirection(value: any): boolean {
  for (const key in AllShipmentsSortDirection) {
    if (Object.prototype.hasOwnProperty.call(AllShipmentsSortDirection, key)) {
      if (
        AllShipmentsSortDirection[
          key as keyof typeof AllShipmentsSortDirection
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function AllShipmentsSortDirectionFromJSON(
  json: any,
): AllShipmentsSortDirection {
  return AllShipmentsSortDirectionFromJSONTyped(json, false);
}

export function AllShipmentsSortDirectionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AllShipmentsSortDirection {
  return json as AllShipmentsSortDirection;
}

export function AllShipmentsSortDirectionToJSON(
  value?: AllShipmentsSortDirection | null,
): any {
  return value as any;
}

export function AllShipmentsSortDirectionToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): AllShipmentsSortDirection {
  return value as AllShipmentsSortDirection;
}
